import React, { FC, ReactNode, useEffect, useState } from 'react';
import { AppBar, Toolbar, styled, Theme } from '@material-ui/core';
import { useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import { Dimensions } from 'src/modules/shared/slices/sidePanel/sidePanelSlice';
import AppBanner from './AppBanner';
import { useLocation } from 'react-router-dom';

const StyledAppBar = styled(AppBar)<Theme, { width?: Dimensions['width']; subheader: boolean }>(
  ({ theme, width, subheader }) => ({
    backgroundColor: theme.palette.white,
    padding: 0,
    color: theme.config.appbarColors.text,
    left: 0,
    width: `calc(100dvw - ${width}px)`,
    borderBottom: subheader ? 'none' : `1px solid ${theme.config.appbarColors.borderColor}`,
  })
);

const AppBarToolbar = styled(Toolbar)<Theme>(({ theme }) => ({
  padding: theme.spacing(1, 3),
  minHeight: theme.config.appbarHeightPx,
}));

interface IAppBarWrapper {
  children: ReactNode;
}

const AppBarWrapper: FC<IAppBarWrapper> = ({ children }) => {
  let location = useLocation();
  const width = useAppSelector((state) => state.sidepanel.sidepanel?.width);
  const [hasSubheader, setHasSubheader] = useState<boolean>(false);

  useEffect(() => {
    setHasSubheader(location.pathname.indexOf('traject') !== -1);
  }, [location]);

  return (
    <StyledAppBar
      id="app-bar"
      key={width}
      width={width}
      elevation={0}
      className="hide-on-print"
      subheader={hasSubheader}
    >
      <AppBanner />
      <AppBarToolbar>{children}</AppBarToolbar>
    </StyledAppBar>
  );
};

export default AppBarWrapper;
